import React from 'react'

export default function Affiliates() {
  return (
    <div>
      <br />
      <div>Our affiliates are ND owned and operated practices exclusively.</div>
      <br />
      <a href="https://www.linkedin.com/in/anoushka-gupta-956a881aa/?originalSubdomain=in">Mindscaping - Anoushka Gupta</a>
    </div>
  )
}
